/**
 * Mobile Navigation Toggle
 * Handles opening/closing the mobile menu with proper accessibility
 */

function initMobileNav() {
  const menuButton = document.getElementById('mobile-menu-button')
  const mobileMenu = document.getElementById('mobile-menu')
  const iconOpen = document.getElementById('menu-icon-open')
  const iconClose = document.getElementById('menu-icon-close')

  if (!menuButton || !mobileMenu) return

  function openMenu() {
    mobileMenu.classList.remove('hidden')
    menuButton.setAttribute('aria-expanded', 'true')
    menuButton.setAttribute('aria-label', 'Close menu')
    iconOpen.classList.add('hidden')
    iconClose.classList.remove('hidden')
  }

  function closeMenu() {
    mobileMenu.classList.add('hidden')
    menuButton.setAttribute('aria-expanded', 'false')
    menuButton.setAttribute('aria-label', 'Open menu')
    iconOpen.classList.remove('hidden')
    iconClose.classList.add('hidden')
  }

  function toggleMenu() {
    const isExpanded = menuButton.getAttribute('aria-expanded') === 'true'
    if (isExpanded) {
      closeMenu()
    } else {
      openMenu()
    }
  }

  menuButton.addEventListener('click', toggleMenu)

  // Close menu when a link is clicked
  const menuLinks = mobileMenu.querySelectorAll('a')
  menuLinks.forEach(function(link) {
    link.addEventListener('click', closeMenu)
  })

  // Close menu on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
      closeMenu()
      menuButton.focus()
    }
  })
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileNav)
} else {
  initMobileNav()
}
